import React, { useCallback, useEffect, useRef, useState, useContext } from 'react';
import { Alert, Box, CircularProgress, Skeleton, useMediaQuery } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { IconButton, Typography, useTheme, ListItemIcon, styled, ListItemButton, Stack, Tooltip } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import SendIcon from '@mui/icons-material/Send';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import './chat-card.scss';
import moment from 'moment';
import { addMessage, getPinnedMessage } from 'app/shared/reducers/chat-messages/chat-Panel';
import { deleteMessage } from 'app/shared/reducers/chat-messages/chat-delete';
import ChatOptions from './chat-options';
import toast from 'react-hot-toast';
import { getAllConversationsById } from 'app/shared/reducers/chat-messages/chat-Panel';
import { setConversations } from 'app/shared/reducers/chat-messages/chat-Panel';
import { sentMessage } from 'app/shared/reducers/chat-messages/chat-post';
import ChatPinIcon from 'app/components/icons/chat-action/pin-icon';
import ChatPinDarkIcon from 'app/components/icons/chat-action/dark-pin';
import copy from 'clipboard-copy';
import { fetchActivityDetails, fetchActivityDetailsUnauthorized, fetchPetitionDetails, fetchUnauthorizedPetitionDetails } from 'app/shared/reducers/activity-home';
import { getReportingReasons } from 'app/shared/reducers/activity/activity-report';
import { onForegroundMessage } from 'app/firebase';
import { deleteChatResponse, getAllEvents, getAllEventsById, updateChatResponse } from 'app/shared/reducers/chat-messages/left-panel';
import CloseIcon from '@mui/icons-material/Close';
import ReplayIcon from './replay-icon';
import ChatReaction from './modals/chat-reaction-emoji';
import OrganiserCrownIcon from 'app/components/icons/activity-card/organiser-crown-icon';
import ModeratorStarIcon from 'app/components/icons/activity-card/moderator-star-icon';
import ChatMediaOption from './modals/chat-media-option';
import axios from 'axios';
import { apiEndPoints } from 'app/utils/data/constants/api-end-points';
import ReactPlayer from 'react-player';
import ChatReactionMessage from './modals/chat-message-emoji';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckIcon from '@mui/icons-material/Check';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import WebSocketContext, { WebSocketProvider } from './WebSocketContext';
import chatEdit, { getChatEdited } from 'app/shared/reducers/chat-messages/chat-edit';
import { encodedTitle, getInitials } from 'app/utils/common-utils/common-utils';
import './chat-feed.scss';
import { Dialog } from '@mui/material';

interface ChatFeedProps {
  openPinnedData: (data: any) => void;
  reportBoxOpen: (data: any) => void;
  editBoxOpen: (data: any) => void;
  activityData: any;
  volunteerButtonClick?: boolean;
  editPass?: any;
  signPetiton?: any;
  changeChat?: any;
  event?: any;
}

const ChatFeed: React.FC<ChatFeedProps> = ({
  openPinnedData,
  reportBoxOpen,
  editBoxOpen,
  activityData,
  volunteerButtonClick,
  editPass,
  signPetiton,
  changeChat,
  event,
}) => {
  const [isSearchBarVisible, setIsSearchBarVisible] = useState(true);
  const [isPinnedCommentDialogOpen, setIsPinnedCommentDialogOpen] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [pinnedData, setPinnedData] = useState(null);
  const [sendPinnedData, setSendPinnedData] = useState(null);
  const [isAnyPinned, setIsAnyPinned] = useState(false);
  const [activityDetails, setActivityDetails] = useState(activityData);
  const viewOnly = event?.payload?.chatDetails.find((chat: any) => chat?.id === activityDetails?.id);
  const [olderItem, setOlderItem] = useState(null);
  const [yesterdayItem, setYesterdayItem] = useState(null);
  const [todayItem, setTodayItem] = useState(null);
  const [unReadItem, setUnReadItem] = useState(null);
  const [message, setMessage] = useState('');
  const [isSendIconEnabled, setIsSendIconEnabled] = useState(false);
  const [activity, setActivity] = useState({});
  const [chat, setChat] = useState(null);
  const [petition, setPetition] = useState({});
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [reply, setReply] = useState(false);
  const [replyData, setReplyData] = useState(null);
  const [reacted, setReacted] = useState(false);
  const [reactedMessage, setReactedMessage] = useState(false);
  const [selectedEmoji, setSelectedEmoji] = useState('');
  const [isImageUploaderOpen, setImageUploaderOpen] = useState(false);
  const [anchorEle, setAnchorEle] = useState(null);
  const [selectedAction, setSelectedAction] = useState('');
  const [fileName, setFileName] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);

  const [files, setFiles] = useState<File[]>([]);
  const [selectedFileNames, setSelectedFileNames] = useState<string[]>([]);
  const [mediaSelected, setMediaSelected] = useState<{ id: number }[]>([]);

  const [mediaType, setMediaType] = useState<string | null>(null);
  const [replybool, setReplybool] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(575));
  const yesterdayLabel = 'YESTERDAY';
  const todayLabel = 'TODAY';
  const unreadLabel = 'UNREAD MESSAGES';
  const messageContainerRef = useRef(null);

  // Local pagination & optimistic message state (client-side only)
  const CHUNK_SIZE = 50; // number of messages to show per chunk (adjustable)
  const [allMessages, setAllMessages] = useState<any[]>([]); // full list from redux (sorted asc)
  const [visibleMessages, setVisibleMessages] = useState<any[]>([]); // messages currently rendered (subset of allMessages)
  const [hasMoreOlder, setHasMoreOlder] = useState(false);
  const [isLoadingOlder, setIsLoadingOlder] = useState(false);
  // pending local optimistic messages keyed by clientTempId
  const pendingLocalRef = useRef<Record<string, any>>({});
  // flag to indicate the most recent render was due to prepend (older load)
  const isPrependingRef = useRef(false);

  const sortMessagesAsc = (msgs: any[]) => {
    return msgs.slice().sort((a, b) => new Date(a.chatPostedOn).getTime() - new Date(b.chatPostedOn).getTime());
  };

  const scrollToBottom = (smooth = false) => {
    const el = messageContainerRef.current as HTMLElement | null;
    if (el) {
      if (smooth) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      else el.scrollTop = el.scrollHeight;
    }
  };

  const preserveScrollWhenPrepend = (addedCount: number) => {
    const el = messageContainerRef.current as HTMLElement | null;
    if (!el) return;
    // preserve user's view by keeping the scroll offset consistent
    const previousScrollHeight = el.scrollHeight;
    // Allow DOM to update then adjust
    requestAnimationFrame(() => {
      const newScrollHeight = el.scrollHeight;
      el.scrollTop = newScrollHeight - previousScrollHeight + el.scrollTop;
    });
  };

  const loadOlderMessages = () => {
    if (isLoadingOlder || !hasMoreOlder) return;
    const el = messageContainerRef.current as HTMLElement | null;
    if (!el) return;

    setIsLoadingOlder(true);

    // find the index of the first visible message inside allMessages
    const firstVisible = visibleMessages && visibleMessages.length > 0 ? visibleMessages[0] : null;
    const firstIndex = firstVisible ? allMessages.findIndex(m => m.id === firstVisible.id || m.clientTempId === firstVisible.clientTempId) : -1;

    let newStart = 0;
    if (firstIndex > 0) {
      newStart = Math.max(0, firstIndex - CHUNK_SIZE);
      const olderChunk = allMessages.slice(newStart, firstIndex);
      // preserve scroll offset while prepending
      const prevScrollHeight = el.scrollHeight;
      isPrependingRef.current = true;
      setVisibleMessages(prev => [...olderChunk, ...(Array.isArray(prev) ? prev : [])]);
      requestAnimationFrame(() => {
        const newScrollHeight = el.scrollHeight;
        el.scrollTop = newScrollHeight - prevScrollHeight + el.scrollTop;
        isPrependingRef.current = false;
        setIsLoadingOlder(false);
        setHasMoreOlder(newStart > 0);
      });
    } else {
      setIsLoadingOlder(false);
      setHasMoreOlder(false);
    }
  };

  const handleScroll = (e: Event) => {
    const el = e.target as HTMLElement;
    if (!el) return;
    // if user scrolled to near top, load older messages
    if (el.scrollTop < 120 && hasMoreOlder && !isLoadingOlder) {
      loadOlderMessages();
    }
  };

  useEffect(() => {
    const el = messageContainerRef.current as HTMLElement | null;
    if (!el) return;
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [messageContainerRef.current, hasMoreOlder, isLoadingOlder, visibleMessages]);

  const getAllConversation = useAppSelector(state => state.chatPanelReducer.chatResponse);
  const pinConversations = useAppSelector(state => state.chatPinReducer.chatResponse);
  const getAllChatResponse = useAppSelector(state => state.leftPanelReducer.chatResponse);
  const deleteConversation = useAppSelector(state => state.chatDeleteReducer.chatResponse);
  const userDetails = useAppSelector(state => state.authentication.account);
  const playerStyle = {
    borderRadius: '3%',
  };

  const isInfoPage = location.pathname === '/chat/info';
  const openImageUploader = event => {
    setImageUploaderOpen(true);
    setAnchorEle(event.currentTarget);
  };

  const cloeImageUploader = item => {
    setAnchorEle(null);
    setImageUploaderOpen(false);
    setSelectedAction(item);
    handleMedia(item);
  };

  const handleMedia = item => {
    setSelectedAction('');
    if (item === 'All') {
      const imageInput = document.getElementById('imageInput');
      if (imageInput) {
        imageInput.click();
      }
    }
  };

  const MAX_FILES = 5;

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    const list = input.files;
    if (!list || list.length === 0) return;

    const MAX_VIDEO_SIZE_MB = 20;
    const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

    const chosen = Array.from(list);
    const valid: File[] = [];
    const names: string[] = [];

    for (const file of chosen) {
      if (file.type.startsWith('video/') && file.size > MAX_VIDEO_SIZE_BYTES) {
        alert(`Video size greater than ${MAX_VIDEO_SIZE_MB}MB is not acceptable.`);
        continue;
      }
      // if (!(file.type.startsWith('image') || file.type.startsWith('video'))) continue;
      if (!(file.type.startsWith('image/') || file.type.startsWith('video/') || file.type === 'application/pdf')) continue;

      valid.push(file);
      names.push(file.name);
    }

    if (valid.length === 0) {
      input.value = '';
      return;
    }

    // how many are already uploaded (mediaSelected) + pending in state (files)
    const alreadyUploaded = Array.isArray(mediaSelected) ? mediaSelected.length : 0;
    const pendingCount = Array.isArray(files) ? files.length : 0;
    const slotsLeft = MAX_FILES - alreadyUploaded - pendingCount;

    if (slotsLeft <= 0) {
      alert(`You can upload a maximum of ${MAX_FILES} files per message`);
      input.value = '';
      return;
    }

    // If user selected more than allowed, trim the selection
    let toAdd = valid;
    let toAddNames = names;
    if (valid.length > slotsLeft) {
      alert(`You can only add ${slotsLeft} files. Extra files were skipped`);
      toAdd = valid.slice(0, slotsLeft);
      toAddNames = names.slice(0, slotsLeft);
    }

    // append only the allowed files
    setFiles(prev => {
      return [...(Array.isArray(prev) ? prev : []), ...toAdd];
    });

    // keep the "names in input" consistent and trimmed relative to alreadyUploaded
    setSelectedFileNames(prev => {
      const combined = [...(Array.isArray(prev) ? prev : []), ...toAddNames];
      const maxNames = MAX_FILES - alreadyUploaded;
      const trimmed = combined.slice(0, maxNames);
      const joined = trimmed.join(', ');
      setMessage(joined);
      if (inputRef.current) inputRef.current.value = joined;
      return trimmed;
    });

    setIsSendIconEnabled(true);
    input.value = ''; // allow same file re-pick later
  };

  const removeSelectedMedia = () => {
    setFileName('');
    setSelectedImage(null);
    setFiles([]);
    setMessage('');
    setMediaSelected([]);

    setReply(false);
    setReplybool(false);
    setReplyData('');
    setDisableImage(false);
    setSelectedFileNames([]); //clear after sending
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    setIsSendIconEnabled(false);
  };

  console.log('setFileName', files);
  const thumbnailContainerStyle = {
    position: 'relative',
    width: '150px',
    height: '150px',
  };

  const playButtonStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '8px',
    color: 'white',
    cursor: 'pointer',
  };

  const ImageComponent = ({ additionalData }) => {
    const imageUrl = additionalData?.link;
    const [open, setOpen] = useState(false);

    const handleClick = () => {
      if (imageUrl) setOpen(true);
    };

    const handleClose = () => setOpen(false);

    return (
      <>
        <Box
          sx={{
            width: 200,
            height: 200,
            cursor: imageUrl ? 'pointer' : 'default',
            overflow: 'hidden',
            borderRadius: '8px',
            border: '1px solid #ddd',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          onClick={handleClick}
        >
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Uploaded"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <span>No Image</span>
          )}
        </Box>

        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullScreen
          PaperProps={{
            sx: {
              backgroundColor: 'black',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative', //To place the close button
            },
          }}
        >
          {/* Close Button */}
          {imageUrl && (
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                top: 16,
                right: 16,
                color: 'white',
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          {/* Image */}
          <Box sx={{ textAlign: 'center' }}>
            <img
              src={imageUrl}
              alt="Full size"
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                objectFit: 'contain',
                borderRadius: '8px',
              }}
            />
          </Box>
        </Dialog>
      </>
    );
  };

  const VideoComponent = ({ additionalData }) => {
    const videoUrl = additionalData?.link;
    return (
      <Box
        sx={{
          position: 'relative',
          width: '150px',
          height: '150px',
          alignContent: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={additionalData?.thumbnail} alt="Video thumbnail"></img>
        <PlayCircleOutlineIcon sx={{ position: 'absolute', color: '#fff' }} onClick={() => window.open(videoUrl, '_blank')} />
      </Box>
    );
  };

  const PdfComponent = ({ additionalData }) => {
    console.log('PDF additionalData:', additionalData);
    const pdfUrl = additionalData?.link;
    console.log('PDF URL:', pdfUrl);

    // Extract filename from URL or path
    let fileName = additionalData?.fileName || pdfUrl?.split('/').pop() || 'Document.pdf';

    console.log('Original fileName:', fileName);

    // If it's a full path (contains \ or /), extract just the filename
    if (fileName.includes('\\')) {
      fileName = fileName.split('\\').pop();
    } else if (fileName.includes('/')) {
      fileName = fileName.split('/').pop();
    }

    console.log('After path extraction:', fileName);

    // Removed timestamp prefix
    if (fileName && fileName.includes('_')) {
      const underscoreIndex = fileName.indexOf('_');
      const prefix = fileName.substring(0, underscoreIndex);

      // Check if prefix is all digits (timestamp)
      if (/^\d+$/.test(prefix)) {
        fileName = fileName.substring(underscoreIndex + 1);
      }
    }

    console.log('Final cleaned fileName:', fileName);

    if (!pdfUrl) {
      console.log('No PDF URL found, rendering placeholder');

      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 12px',
            borderRadius: '8px',
            backgroundColor: '#f5f5f5',
            border: '1px solid #e0e0e0',
            maxWidth: '300px',
            opacity: 0.6,
          }}
        >
          <PictureAsPdfIcon
            sx={{
              fontSize: '24px',
              color: '#d32f2f',
              flexShrink: 0,
            }}
          />
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '13px',
              fontWeight: 500,
            }}
          >
            {fileName} (No URL)
          </Typography>
        </Box>
      );
    }

    return (
      <a
        href={pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
        onClick={(e) => {
          console.log('PDF clicked, URL:', pdfUrl);
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 12px',
            borderRadius: '8px',
            backgroundColor: '#f5f5f5',
            border: '1px solid #e0e0e0',
            cursor: 'pointer',
            maxWidth: '300px',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: '#eeeeee',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            },
          }}
        >
          {/* PDF Icon */}
          <PictureAsPdfIcon
            sx={{
              fontSize: '24px',
              color: '#d32f2f',
              flexShrink: 0,
            }}
          />

          {/* File name */}
          <Typography
            variant="body2"
            sx={{
              color: '#333',
              fontSize: '13px',
              fontWeight: 500,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {fileName}
          </Typography>
        </Box>
      </a>
    );
  };

  const fetchConversations = async item => {
    const myDetailsAccount = localStorage.getItem('MyDetailsAccount');
    const userId = myDetailsAccount ? JSON.parse(myDetailsAccount)?.id : null;
    const payload = {
      eventId: item?.id ? item?.id : 0,
      eventType: item?.eventType ? item?.eventType : '',
      userId: userId,
    };

    if (payload?.eventId != 0) {
      try {
        const response = await dispatch(getAllConversationsById(payload));
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    }
  };

  const autoScrollToBottom = () => {
    const messageContainer = document.getElementById('my_div');

    if (messageContainer) {
      const mediaElements = messageContainer.querySelectorAll('img, video');
      const mediaLoadPromises = Array.from(mediaElements).map((mediaElement: HTMLImageElement | HTMLVideoElement) => {
        return new Promise<void>(resolve => {
          if ('complete' in mediaElement && mediaElement.complete) {
            resolve();
          } else {
            mediaElement.addEventListener('load', () => resolve());
            mediaElement.addEventListener('error', () => resolve());
          }
        });
      });

      Promise.all(mediaLoadPromises).then(() => {
        messageContainer.scrollTop = messageContainer.scrollHeight;
      });
    }
  };

  const fetchActivity = async () => {
    let payload = {
      eventId: 0,
      eventType: '',
    };

    if (localStorage.getItem('dataKey')) {
      const keysJSON = await localStorage.getItem('dataKey');
      const keys = JSON.parse(keysJSON);
      payload = {
        eventId: keys.id,
        eventType: keys.eventType?.toUpperCase(),
      };
    }

    try {
      let response;
      if (payload.eventId == 0) {
        response = await dispatch(getAllEvents());
      } else {
        if (payload) response = await dispatch(getAllEventsById(payload));
      }
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  };

  useEffect(() => {
    if (pinnedData != undefined && pinnedData != null) {
      setReplybool(true);
      autoScrollToBottom();
    } else {
      setReplybool(false);
    }
  }, [pinnedData]);

  // Keep UI groups in sync with the currently visible messages
  const lastVisibleTailRef = useRef<string | number | null>(null);
  const lastUpdateIsReactionRef = useRef(false); // new: mark next update as reaction-driven to suppress auto-scroll
  useEffect(() => {
    if (Array.isArray(visibleMessages)) {
      dateChats(visibleMessages);

      // if new message appended at tail and not due to prepend, scroll to bottom
      const last = visibleMessages.length ? visibleMessages[visibleMessages.length - 1] : null;
      const lastId = last ? last.id || last.clientTempId : null;
      if (lastId && lastVisibleTailRef.current !== lastId && !isPrependingRef.current) {
        // If this update was caused by a reaction, skip auto-scrolling and clear the flag.
        if (lastUpdateIsReactionRef.current) {
          lastUpdateIsReactionRef.current = false;
        } else {
          // scroll to bottom for new appended messages
          requestAnimationFrame(() => scrollToBottom());
        }
      }
      lastVisibleTailRef.current = lastId;
    }
  }, [visibleMessages]);

  useEffect(() => {
    if (localStorage.getItem('chatFeedDetails') != undefined) {
      setActivityDetails(JSON.parse(localStorage.getItem('chatFeedDetails')));
    }
  }, [localStorage.getItem('chatFeedDetails')]);

  useEffect(() => {
    if (reply != undefined && reply != null) {
      autoScrollToBottom();
    } else {
      setReplybool(false);
    }
  }, [reply]);

  useEffect(() => {
    if (signPetiton) {
      fetchConversations(activityData);
    }
  }, [signPetiton]);

  useEffect(() => {
    if (activityData) {
      fetchConversations(activityData);
    }
  }, [activityData, changeChat]);

  // When switching chats, clear client-local optimistic messages and visible window
  useEffect(() => {
    // reset local pagination and pending messages when chat changes
    pendingLocalRef.current = {};
    setAllMessages([]);
    setVisibleMessages([]);
    setHasMoreOlder(false);
  }, [activityData?.id]);
  const [disableImage, setDisableImage] = useState<any>(false);

  useEffect(() => {
    // only run when we actually have files to upload
    if (!Array.isArray(files) || files.length === 0) return;

    let isCancelled = false;
    const sendFiles = async () => {
      try {
        setDisableImage(true);
        const uploadedMedia: any[] = [];

        for (const file of files) {
          let endpoint = '';
          let mediaType = '';
          const formData = new FormData();
          formData.append('file', file as Blob);

          if (file.type.includes('image')) {
            endpoint = apiEndPoints.imageUpload;
            mediaType = 'images';
          } else if (file.type.includes('video')) {
            endpoint = apiEndPoints.videoUpload;
            mediaType = 'videos';
          } else if (file.type === 'application/pdf' || file.type.includes('pdf')) {
            endpoint = apiEndPoints.pdfUpload;
            mediaType = 'pdf';
          } else {
            // skip unknown types
            continue;
          }

          const response = await axios.post<any>(endpoint, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 5 * 60 * 1000,
          });

          if (response.status === 201) {
            uploadedMedia.push({
              id: response.data.id,
              type: mediaType,
              link: response.data.link || response.data.url || response.data.path,
              fileName: response.data.fileName || response.data.name || file.name
            });
          }
        }

        if (!isCancelled && uploadedMedia.length > 0) {
          // append to existing mediaSelected
          setMediaSelected(prev => [...(Array.isArray(prev) ? prev : []), ...uploadedMedia]);
          // set mediaType: if all images -> 'image', if all videos -> 'video', if all pdfs -> 'pdf', else 'mixed'
          const types = new Set(uploadedMedia.map(m => m.type));
          if (types.size === 1) {
            if (types.has('images')) setMediaType('image');
            else if (types.has('videos')) setMediaType('video');
            else if (types.has('pdf')) setMediaType('pdf');
          } else {
            setMediaType('mixed');
          }
        }
      } catch (error) {
        console.error('upload error', error);
      } finally {
        if (!isCancelled) {
          setDisableImage(false);
          setFiles([]);
          setSelectedFileNames([]);
        }
      }
    };

    sendFiles();

    return () => {
      isCancelled = true;
    };
  }, [files]);

  useEffect(() => {
    const data = getAllChatResponse?.chatDetails?.filter(chatItem => chatItem?.id === activityData?.id);
    if (volunteerButtonClick) {
      fetchEventInfo();
    }
  }, [isSubmitClicked, volunteerButtonClick]);

  const fetchEventInfo = async () => {
    if (activityDetails?.eventType === 'Activity') {
      const action = consentPending ? fetchActivityDetailsUnauthorized : fetchActivityDetails;
      let response = await dispatch(action(activityDetails?.id));
      setActivityDetails(response?.payload);
      if (response.payload) localStorage.setItem('chatFeedDetails', JSON.stringify(response.payload));
    } else if (activityDetails?.eventType === 'Petition') {
      const action = consentPending ? fetchUnauthorizedPetitionDetails : fetchPetitionDetails;
      let response = await dispatch(action(activityDetails?.id));
      if (response.payload) localStorage.setItem('chatFeedDetails', JSON.stringify(response.payload));
      setActivityDetails(response?.payload);
    }
  };

  useEffect(() => {
    if (chatData?.length > 0 && !reactedMessage) {
      autoScrollToBottom();
    }
  }, [chatData, reactedMessage]);

  // Maintain an internal, sorted message list and show a chunk (LIFO-style view: newest at bottom)
  useEffect(() => {
    if (!Array.isArray(getAllConversation)) return;

    const sorted = sortMessagesAsc(getAllConversation);
    const pendingAll = Object.values(pendingLocalRef.current || {});

    const pendingNotInServer = pendingAll.filter(pMsg => {
      return !sorted.some(m => {
        if (m.id && pMsg.id && m.id === pMsg.id) return true;
        if (m.clientTempId && pMsg.clientTempId && m.clientTempId === pMsg.clientTempId) return true;
        if (
          m.message === pMsg.message &&
          m.userId === pMsg.userId &&
          m.eventId === pMsg.eventId &&
          Math.abs(new Date(m.chatPostedOn).getTime() - new Date(pMsg.chatPostedOn).getTime()) < 5000
        ) {
          return true;
        }
        return false;
      });
    });

    const displaySorted = [...sorted, ...pendingNotInServer];

    // ONLY update state if data actually changed
    setAllMessages(prev => {
      if (JSON.stringify(prev) === JSON.stringify(sorted)) return prev;
      return sorted;
    });

    const start = Math.max(0, displaySorted.length - CHUNK_SIZE);
    const newVisible = displaySorted.slice(start);

    setVisibleMessages(prev => {
      if (JSON.stringify(prev) === JSON.stringify(newVisible)) return prev;
      return newVisible;
    });

    // Pinned messages - only update if changed
    const pinnedMessages = sorted.filter(item => item.pinned === true);
    setPinnedData(prev => {
      const newPinned = pinnedMessages.length > 0 ? pinnedMessages[0] : null;
      if (JSON.stringify(prev) === JSON.stringify(newPinned)) return prev;
      return newPinned;
    });

    setSendPinnedData(prev => {
      if (JSON.stringify(prev) === JSON.stringify(pinnedMessages)) return prev;
      return pinnedMessages;
    });

    const isAnyPinned = sorted.some(item => item?.pinTop === true);
    setIsAnyPinned(prev => prev === isAnyPinned ? prev : isAnyPinned);

    // CRITICAL FIX: Only call dateChats if displaySorted actually changed
    setChatData(prev => {
      if (JSON.stringify(prev) === JSON.stringify(displaySorted)) return prev;
      // Only call dateChats when data changes
      dateChats(displaySorted);
      return displaySorted;
    });

    setHasMoreOlder(start > 0);

    if (!lastUpdateIsReactionRef.current) {
      requestAnimationFrame(() => scrollToBottom());
    }
    lastUpdateIsReactionRef.current = false;

    setMessage('');
  }, [getAllConversation]);

  useEffect(() => {
    if (pinConversations) {
      fetchConversations(activityData);
      const pinnedMessages = Array.isArray(pinConversations?.data) ? pinConversations?.data?.filter(item => item.pinned === true) : [];
      setPinnedData(pinnedMessages ? pinnedMessages[0] : []);
      setSendPinnedData(pinnedMessages ? pinnedMessages : []);
      dateChats(getAllConversation);
    }
  }, [pinConversations]);

  const pinMessage = async item => {
    const userid2 = JSON.parse(localStorage?.getItem('MyDetailsAccount'));
    const payload = {
      messageId: item.id,
      payload: {
        userId: userid2?.id,
        eventId: item.eventId,
        eventType: item.eventType,
      },
    };
    try {
      const response = await dispatch(getPinnedMessage(payload));
      if (response?.meta?.requestStatus === 'fulfilled') {
        toast.success(response?.payload?.message);
      } else {
        toast.error('Only Organizers can pin message');
      }
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  };

  const deleteMessageById = async item => {
    const userid2 = JSON.parse(localStorage?.getItem('MyDetailsAccount'));
    const editPay = {
      userId: userid2?.id,
      eventId: item?.eventId,
      eventType: item?.eventType,
      message: item.message,
      replyToMessageId: item.replyToMessageId,
      multimedia: null,
      recurringActivity: activityData?.recurringEvent ? true : false,
      chatMessageType: 'DELETE',
      messageId: item?.id,
    };
    if (isConnected && webSocket.current) {
      sendMessage(JSON.stringify(editPay));
    }
    setReactedMessage(true);
  };

  const handleCopyMessage = async item => {
    const message = item.message;
    const eventGallery = item.eventGallery;

    try {
      if (eventGallery && eventGallery.length > 0) {
        const imageUrl = eventGallery[0].link;
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const dataUrl = URL.createObjectURL(blob);
        const textarea = document.createElement('textarea');
        textarea.value = dataUrl;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        toast.success('Image Copied to clipboard');
      } else {
        await copy(message);
        toast.success('Message Copied to clipboard');
      }
    } catch (error) {
      toast.error('Copy failed');
    }
  };

  const handleMenuItemClick = (item, message) => {
    if (item === 'pin') {
      setReplybool(!replybool);
      pinMessage(message);
    } else if (item === 'copy') {
      handleCopyMessage(message);
    } else if (item === 'delete') {
      deleteMessageById(message);
    } else if (item === 'report') {
      setChat(message);
      reportBoxOpen(message);
    } else if (item === 'edit') {
      handleEdit(message);
    }
  };

  const handleReply = message => {
    setReply(true);
    setReplybool(true);
    setReplyData(message);
  };

  const handleEmojiSelect = emoji => {
    setSelectedEmoji(emoji);
  };

  const handleEmojiMessageSelect = emoji => {
    setSelectedEmoji(emoji);
    const newText = emoji;
    inputRef.current.value = inputRef.current.value + newText;
    setMessage(inputRef.current.value + newText);
    setIsSendIconEnabled(newText.trim().length > 0);
  };

  const [chatMessages, setMock] = useState([]);
  const { webSocket, isConnected, sendMessage, messageTrigger } = useContext(WebSocketContext);
  const handleTextareaChange = useCallback(event => {
    setMessage(event.target.value);
    const newText = event.target.value;
    setIsSendIconEnabled(newText.trim().length > 0);
  }, []);
  const inputRef = useRef(null);

  const [wholeMessages, setWholeMessages] = useState<any>([]);
  useEffect(() => {
    if (isConnected) {
      console.log('WebSocket is connected and activityDetails are available.');
      const handleWebSocketMessage = (event: MessageEvent) => {
        try {
          const parsedBody = JSON.parse(event.data);
          if (parsedBody && parsedBody.message) {
            console.log('Received WebSocket message:', parsedBody);
            const lastMessage = parsedBody;

            const myDetailsAccount = localStorage.getItem('MyDetailsAccount');
            const userId = myDetailsAccount ? JSON.parse(myDetailsAccount)?.id : null;

            // Send READ receipt for messages from others
            if (lastMessage?.userId !== userId && lastMessage?.eventId === activityData?.id) {
              const readPayload = {
                eventType: lastMessage?.eventType,
                eventId: lastMessage?.eventId,
                userId,
                chatMessageType: 'READ',
                messageId: lastMessage?.id,
              };

              if (isConnected && webSocket.current) {
                sendMessage(JSON.stringify(readPayload));
              }
            }

            // CRITICAL FIX: Detect message type
            const isEdit = lastMessage?.edited && !lastMessage?.deleted && (!lastMessage?.chatReactions || lastMessage?.chatReactions?.length === 0);
            const isReaction = lastMessage?.chatReactions && lastMessage?.chatReactions?.length > 0 && !lastMessage?.deleted && !lastMessage?.edited;
            const isDelete = lastMessage?.deleted;

            // Handle EDIT messages
            if (isEdit) {
              lastUpdateIsReactionRef.current = true;
              const updatedConversations = getAllConversation.map(item =>
                item.id === lastMessage?.id ? lastMessage : item
              );
              // ONLY update Redux - remove setChatData, fetchConversations, dateChats
              dispatch(setConversations(updatedConversations));
            }
            // Handle REACTION messages
            else if (isReaction) {
              lastUpdateIsReactionRef.current = true;
              const updatedConversations = getAllConversation.map(item =>
                item.id === lastMessage?.id ? lastMessage : item
              );
              // ONLY update Redux - remove setChatData, fetchConversations, dateChats
              dispatch(setConversations(updatedConversations));
            }
            // Handle DELETE messages
            else if (isDelete) {
              const filteredConversations = getAllConversation.filter(
                conversation => conversation.id !== lastMessage?.id
              );
              // ONLY update Redux - remove setChatData, fetchConversations, dateChats
              dispatch(setConversations(filteredConversations));
            }
            // Handle NEW/REGULAR messages
            else if (lastMessage.eventId === activityData?.id) {
              const clientTempId = lastMessage?.clientTempId;

              if (clientTempId && pendingLocalRef.current[clientTempId]) {
                delete pendingLocalRef.current[clientTempId];
                dispatch(addMessage(lastMessage));
                requestAnimationFrame(() => scrollToBottom());
              } else {
                const isFromMe = lastMessage?.userId === userId;

                if (isFromMe) {
                  const matchedOptimistic = Object.values(pendingLocalRef.current || {}).find(pMsg => {
                    return (
                      pMsg.message === lastMessage.message &&
                      pMsg.eventId === lastMessage.eventId
                    );
                  });

                  if (matchedOptimistic) {
                    delete pendingLocalRef.current[matchedOptimistic.clientTempId];
                    dispatch(addMessage(lastMessage));
                    requestAnimationFrame(() => scrollToBottom());
                    return;
                  }
                }

                const existingIndex = getAllConversation.findIndex(
                  message => message.id === lastMessage.id
                );

                if (existingIndex === -1) {
                  dispatch(addMessage(lastMessage));
                } else {
                  const updatedConversations = [...getAllConversation];
                  updatedConversations[existingIndex] = lastMessage;
                  // ONLY update Redux
                  dispatch(setConversations(updatedConversations));
                }
              }
            } else {
              dispatch(updateChatResponse(lastMessage));
            }
          } else {
            console.warn('Received message does not contain expected structure:', parsedBody);
          }
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      if (webSocket.current) {
        console.log('check log');
        webSocket.current.onmessage = handleWebSocketMessage;
      }

      return () => {
        if (webSocket.current) {
          webSocket.current.onmessage = null;
        }
      };
    } else {
      fetchConversations(activityData);
      console.log('WebSocket is not connected or activityDetails are missing.');
    }
  }, [isConnected, webSocket, getAllConversation, activityData]);

  const handleReactClose = (data: any) => {
    console.log('data', data);
    // Flag will be set by WebSocket handler when response arrives
    const userid2 = JSON.parse(localStorage?.getItem('MyDetailsAccount'));
    const editPay = {
      userId: userid2?.id,
      eventId: data?.payload?.eventId,
      eventType: data?.payload?.eventType,
      message: null,
      replyToMessageId: null,
      multimedia: null,
      recurringActivity: activityData?.recurringEvent ? true : false,
      chatMessageType: 'REACT',
      messageId: data?.messageId,
      reactType: data?.payload?.reactType,
    };
    if (isConnected && webSocket.current) {
      sendMessage(JSON.stringify(editPay));
    }
    setReacted(false);
    setReactedMessage(true);
    setReplybool(false);
  };

  const handleSendIconClick = reply => {
    if (consentPending) {
      toast.error('Your account is awaiting parental approval. Messaging is not available until your parent approves.');
      return;
    }
    const userid2 = JSON.parse(localStorage?.getItem('MyDetailsAccount'));
    const payload = {
      userId: userid2?.id,
      eventId: activityData?.id,
      eventType: activityData?.eventType,
      message: Array.isArray(mediaSelected) && mediaSelected.length > 0 ? ' ' : inputRef.current.value,
      replyToMessageId: reply ? replyData?.id : 0,
      multimedia: Array.isArray(mediaSelected) ? mediaSelected : [],
      recurringActivity: activityData?.recurringEvent ? true : false,
      chatMessageType: null,
    };

    // optimistic local render: create a temp id and append to visibleMessages
    const clientTempId = `temp-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    const messageText = payload.message;
    const tempMessage = {
      id: clientTempId,
      clientTempId,
      userId: userid2?.id,
      name: userid2?.firstName || userid2?.name || 'You',
      profileImage: userid2?.imageUrl || userid2?.profileImage,
      eventId: activityData?.id,
      eventType: activityData?.eventType,
      chatPostedOn: new Date().toISOString(),
      message: messageText,
      multimedia: Array.isArray(mediaSelected) ? mediaSelected : [],
      chatReactions: [],
      messageType: 'CHAT',
      optimistic: true,
    };

    // add to pending map and visible list
    pendingLocalRef.current[clientTempId] = tempMessage;
    setVisibleMessages(prev => [...(Array.isArray(prev) ? prev : []), tempMessage]);

    // include temp id in payload so server can echo back if supported
    payload['clientTempId'] = clientTempId;

    if (isConnected && webSocket.current) {
      sendMessage(JSON.stringify(payload));
    }

    // reset UI state
    setMessage('');
    setMediaSelected([]);
    setIsSendIconEnabled(false);
    setReply(false);
    setReplybool(false);
    setReplyData('');
    setFiles([]);
    setReactedMessage(false);
    setSelectedFileNames([]); // clear after sending
    if (inputRef.current) inputRef.current.value = '';
    // ensure new message visible
    requestAnimationFrame(() => scrollToBottom(true));
  };

  useEffect(() => {
    if (editPass !== undefined && isConnected && webSocket.current) {
      const handleEditPass = async () => {
        if (editPass !== undefined && isConnected && webSocket.current) {
          const myDetailsAccount = localStorage.getItem('MyDetailsAccount');
          const userid2 = myDetailsAccount ? JSON.parse(myDetailsAccount) : null;
          const editPay = {
            userId: userid2?.id,
            eventId: editPass?.eventId,
            eventType: editPass?.eventType,
            message: editPass?.message,
            replyToMessageId: null,
            multimedia: null,
            recurringActivity: activityData?.recurringEvent ? true : false,
            chatMessageType: 'EDIT',
            messageId: editPass?.messageId,
          };
          if (isConnected && webSocket.current) {
            sendMessage(JSON.stringify(editPay));
          }
        }
      };
      handleEditPass();
    }
  }, [editPass, isConnected, webSocket]);

  const postMessage = async item => {
    try {
      const response = await dispatch(sentMessage(item));
      if (response.meta.requestStatus === 'fulfilled') {
      } else {
        toast.error('Error , Message not sent');
      }
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  };

  const memoizedDateChats = React.useMemo(() => {
    if (!Array.isArray(chatData) || chatData.length === 0) {
      return { olderItem: [], yesterdayItem: [], todayItem: [], unReadItem: [] };
    }

    const formatTimestamp = timestamp => moment(timestamp).utc().local().format('YYYY-MM-DD HH:mm:ss');
    const today = formatTimestamp(moment());
    const yesterday = formatTimestamp(moment().subtract(1, 'day'));

    const todayItems = chatData.filter(item => {
      const itemTimestamp = formatTimestamp(item.chatPostedOn);
      return moment(itemTimestamp).isSameOrAfter(today, 'day');
    });

    const yesterdayItems = chatData.filter(item => {
      const itemTimestamp = formatTimestamp(item.chatPostedOn);
      return moment(itemTimestamp).isSame(yesterday, 'day');
    });

    const olderItems = chatData.filter(item => {
      const itemTimestamp = formatTimestamp(item.chatPostedOn);
      return !moment(itemTimestamp).isSame(yesterday, 'day') && !moment(itemTimestamp).isSameOrAfter(today, 'day');
    });

    const unReadItems = [];
    for (let i = todayItems.length - 1; i >= 0; i--) {
      const item = todayItems[i];
      if (item.id >= activityData?.lastMessageId) {
        unReadItems.unshift(item);
        todayItems.splice(i, 1);
      }
    }

    return {
      olderItem: olderItems,
      yesterdayItem: yesterdayItems,
      todayItem: todayItems,
      unReadItem: unReadItems,
    };
  }, [chatData, activityData?.lastMessageId]);

  const dateChats = DATA => {
    if (!Array.isArray(DATA)) {
      return;
    }
    const formatTimestamp = timestamp => moment(timestamp).utc().local().format('YYYY-MM-DD HH:mm:ss');
    const today = formatTimestamp(moment());
    const yesterday = formatTimestamp(moment().subtract(1, 'day'));

    const todayItems = DATA.filter(item => {
      const itemTimestamp = formatTimestamp(item.chatPostedOn);
      return moment(itemTimestamp).isSameOrAfter(today, 'day');
    });

    const yesterdayItems = DATA.filter(item => {
      const itemTimestamp = formatTimestamp(item.chatPostedOn);
      return moment(itemTimestamp).isSame(yesterday, 'day');
    });

    const olderItems = DATA.filter(item => {
      const itemTimestamp = formatTimestamp(item.chatPostedOn);
      return !moment(itemTimestamp).isSame(yesterday, 'day') && !moment(itemTimestamp).isSameOrAfter(today, 'day');
    });

    const unReadItems = [];
    for (let i = todayItems.length - 1; i >= 0; i--) {
      const item = todayItems[i];
      if (item.id >= activityData?.lastMessageId) {
        unReadItems.unshift(item);
        todayItems.splice(i, 1);
      }
    }

    // Only update if changed
    setUnReadItem(prev => JSON.stringify(prev) === JSON.stringify(unReadItems) ? prev : unReadItems);
    setTodayItem(prev => JSON.stringify(prev) === JSON.stringify(todayItems) ? prev : todayItems);
    setYesterdayItem(prev => JSON.stringify(prev) === JSON.stringify(yesterdayItems) ? prev : yesterdayItems);
    setOlderItem(prev => JSON.stringify(prev) === JSON.stringify(olderItems) ? prev : olderItems);
  };

  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const consentPending = useAppSelector(state => state.authentication.consentPending);
  const isDarkMode = theme.palette.mode === 'dark';
  const navigate = useNavigate();

  const handlePinnedCommentClick = () => {
    setIsPinnedCommentDialogOpen(true);
    openPinnedData(sendPinnedData);
  };

  const goToProfilePage = message => {
    if (consentPending) {
      toast.error('Parental consent is required before you can view profiles.');
      return;
    }
    navigate(`/profile/${message?.name?.replace(/\s+/g, '-')}-${message?.userId}`);
  };

  const closeReply = () => {
    setReply(false);
    setReplybool(false);
  };

  const handleEdit = comment => {
    editBoxOpen(comment);
  };

  const navigateToEvent = event => {
    if (event?.eventType === 'ACTIVITY') {
      if (event?.recurringEvent) {
        navigate(`/recurringactivity/${encodedTitle(event?.title)}-${event?.id}`);
      } else {
        navigate(`/activity/${encodedTitle(event?.title)}-${event?.id}`);
      }
    } else if (event?.eventType === 'PETITION') {
      navigate(`/petition/${encodedTitle(event?.title)}-${event?.id}`);
    }
  };

  const navigateToInfo = event => {
    isMobile ? navigate('info') : navigateToEvent(event);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      const reply = inputRef.current.value;
      handleSendIconClick(reply);
    }
  };

  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: '100%',
        maxWidth: '100%',
        backgroundColor: 'secondary.dark',
        paddingTop: '0',
        borderRadius: '15px 15px 15px 15px',
      }}
    >
      <div>
        <Box onClick={() => navigateToInfo(activityData)}>
          <ListItemButton
            alignItems="center"
            sx={{
              backgroundColor: isDarkMode ? 'secondary.dark' : '#FAF9FF',
              display: 'flex',
              borderRadius: '15px 15px 0px 0px',
              transition: 'background-color 0s ease',
            }}
          >
            <Box display="flex" alignItems="center">
              <ListItemAvatar>
                <Avatar
                  sx={{ borderRadius: '14px' }}
                  alt={pinnedData?.name}
                  src={
                    activityData?.eventProfileLink ? activityData?.eventProfileLink : getAllChatResponse?.chatDetails[0]?.eventProfileLink
                  }
                />
              </ListItemAvatar>
            </Box>
            <Box fontSize={'16px'} fontWeight={600} fontFamily={'Manrope'}>
              {activityData?.title ? activityData?.title : getAllChatResponse?.chatDetails[0]?.title}
            </Box>
          </ListItemButton>
        </Box>
        <div
          className={`toScroll ${replybool ? `chat-scroll-container-reply` : `chat-scroll-container`}`}
          id="my_div"
          ref={messageContainerRef}
          style={{ overflow: 'hidden scroll' }}
        >
          {pinnedData ? (
            <ListItemButton
              sx={{ backgroundColor: !isDarkMode ? '#F6F7F8' : '#6f6f6f', display: 'Block' }}
              onClick={handlePinnedCommentClick}
            >
              <Stack>
                <ListItemIcon sx={{ color: isDarkMode ? '#b58f28' : '', marginLeft: '55px' }}>
                  <Badge
                    color="primary"
                    variant="dot"
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    sx={{
                      '& .MuiBadge-badge': {
                        bottom: '10px',
                        right: '8px',
                        backgroundColor: 'primary.light',
                      },
                    }}
                  >
                    {!isDarkMode ? <ChatPinIcon /> : <ChatPinDarkIcon />}
                  </Badge>
                </ListItemIcon>
              </Stack>
              <Box display="-webkit-inline-box;" flexDirection="column" alignItems="center">
                <ListItemAvatar>
                  <Avatar alt={`${pinnedData?.profileImage}` ? '' : getInitials(pinnedData?.name)} src={pinnedData?.profileImage}>
                    {' '}
                    {getInitials(pinnedData?.name)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <React.Fragment>
                      <Typography
                        sx={{
                          display: 'inline',
                          fontWeight: '600',
                          color: pinnedData?.userId === userDetails?.id ? 'primary.light' : 'inherit',
                        }}
                        component="span"
                        variant="body2"
                        color={isDarkMode ? '#ffce00' : 'text.primary'}
                      >
                        {pinnedData?.userId == userDetails?.id ? 'You' : pinnedData?.name} &nbsp;
                      </Typography>
                      <Typography
                        component="span"
                        variant="caption"
                        color="text.secondary"
                        aria-label={`Posted on ${moment(pinnedData?.chatPostedOn).format('LLL')}`}
                      >
                        {moment(pinnedData?.chatPostedOn).fromNow()}
                      </Typography>
                    </React.Fragment>
                  }
                  secondary={
                    pinnedData?.message
                      ? pinnedData?.message.length > 50
                        ? pinnedData?.message?.slice(0, 50) + '...'
                        : pinnedData?.message
                      : null
                  }
                />
              </Box>
            </ListItemButton>
          ) : (
            ''
          )}
          <div>
            {(Array.isArray(getAllConversation) && getAllConversation.length > 0) || (Array.isArray(visibleMessages) && visibleMessages.length > 0) ? (
              <>
                {Array.isArray(memoizedDateChats.olderItem) && memoizedDateChats.olderItem?.length > 0 && (
                  <>
                    {memoizedDateChats.olderItem?.map((message, index) => (
                      <ListItemButton className="d-flex  bd-highlight" alignItems="flex-start" key={index}>
                        {message?.messageType !== 'CHAT' ? (
                          <Alert severity="success" sx={{ minWidth: '100%' }}>
                            {message?.message}
                          </Alert>
                        ) : (
                          <>
                            <ListItemAvatar className="bd-highlight" onClick={() => goToProfilePage(message)}>
                              <Badge
                                overlap="circular"
                                onClick={() => navigate(`/profile/${message?.name?.replace(/\s+/g, '-')}-${message?.userId}`)}
                                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                badgeContent={
                                  message?.organizer ? (
                                    <OrganiserCrownIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : message?.moderator ? (
                                    <ModeratorStarIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : null
                                }
                              >
                                <Avatar
                                  alt={`${message?.name}` ? '' : getInitials(message?.name)}
                                  src={message?.profileImage}
                                  sx={{
                                    fontSize: message?.name ? 'default' : '12px',
                                  }}
                                >
                                  {' '}
                                  {getInitials(message?.name)}
                                </Avatar>
                              </Badge>
                            </ListItemAvatar>
                            <Box className="bd-highlight">
                              {message?.replyToMessageId !== 0 && message?.replyToMessageId !== null && (
                                <>
                                  <Box className={isDarkMode ? `chat-container-dark` : `chat-container`}>
                                    <div className={isDarkMode ? 'reply-section' : 'reply-section'}>
                                      <div className="reply-info">
                                        <p
                                          className="reply-user"
                                          style={{
                                            color:
                                              message?.replyToMessageUserId === userDetails?.id
                                                ? isDarkMode
                                                  ? '#ffce00'
                                                  : 'primary.light'
                                                : 'inherit',
                                          }}
                                        >
                                          {message?.replyToMessageUserId === userDetails?.id
                                            ? message?.replyToMessageUser
                                            : message?.replyToMessageUser}
                                        </p>
                                        <span className="reply-text">{message?.replyToMessage}</span>
                                      </div>
                                    </div>
                                  </Box>
                                </>
                              )}
                              <ListItemText
                                primary={
                                  <React.Fragment>
                                    <Typography
                                      sx={{
                                        display: 'inline',
                                        fontWeight: '600',
                                        color:
                                          message?.replyToMessageUserId === userDetails?.id
                                            ? isDarkMode
                                              ? '#ffce00'
                                              : 'primary.light'
                                            : 'inherit',
                                      }}
                                      component="span"
                                      variant="body2"
                                      color={isDarkMode ? '#ffce00' : 'text.primary'}
                                    >
                                      {message?.userId === userDetails?.id ? 'You' : message.name} &nbsp;
                                    </Typography>
                                    {moment(message?.chatPostedOn).fromNow()}
                                    <>
                                      {Array.isArray(message?.eventGallery) && message.eventGallery.length > 0 && (
                                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                          {message.eventGallery.map((media, index) => (
                                            <Box key={`${media.id || index}-${media.type}`}>
                                              {media.type === 'images' && <ImageComponent additionalData={media} />}
                                              {media.type === 'videos' && <VideoComponent additionalData={media} />}
                                              {media.type === 'pdf' && <PdfComponent additionalData={media} />}
                                            </Box>
                                          ))}
                                        </Box>
                                      )}
                                    </>
                                  </React.Fragment>
                                }
                                sx={{ wordBreak: 'break-all' }}
                                secondary={message?.message}
                              />
                              <div style={{ display: 'flex', gap: '8px' }}>
                                {message?.chatReactions?.length > 0 &&
                                  message?.chatReactions?.map((reaction, index) => (
                                    <Box
                                      sx={{
                                        width: '40px',
                                        height: '25px',
                                        background: isDarkMode ? '#1f1f26' : '#e0e0e0',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: '#fff',
                                        borderRadius: '10px',
                                        fontSize: ' 16px',
                                        display: 'flex',
                                        cursor: 'pointer',
                                      }}
                                      key={index}
                                    >
                                      <Typography>{reaction?.reaction}</Typography>
                                      <Typography sx={{ color: !isDarkMode ? '#292D34' : '' }}>{reaction?.count}</Typography>
                                    </Box>
                                  ))}
                              </div>
                            </Box>
                            <Box className="ms-auto  bd-highlight">
                              {((activityDetails?.activityStatus === 'OPEN' && activityDetails?.participant === true) ||
                                (activityDetails?.petitionStatus === 'OPEN' && activityDetails?.organiser === true)) && (
                                  <span className="d-flex align-items-center">
                                    {message?.pinned === true && (
                                      <Tooltip title="Pinned">
                                        <ChatPinIcon sx={{ fontSize: 'medium' }}></ChatPinIcon>
                                      </Tooltip>
                                    )}
                                    <Tooltip title="Reaction">
                                      <ChatReaction
                                        message={message}
                                        chatData={getAllConversation}
                                        onSelectEmoji={handleEmojiSelect}
                                        onClose={data => handleReactClose(data)}
                                      />
                                    </Tooltip>
                                    <Tooltip title="Reply">
                                      <ReplayIcon className="m-2" sx={{ fontSize: 'medium' }} onClick={() => handleReply(message)} />
                                    </Tooltip>
                                    <Tooltip title="More">
                                      <ChatOptions
                                        handleMenuItemClick={handleMenuItemClick}
                                        message={message}
                                        chatDetails={activityDetails}
                                      />
                                    </Tooltip>
                                  </span>
                                )}
                            </Box>
                          </>
                        )}
                      </ListItemButton>
                    ))}
                  </>
                )}
                {Array.isArray(memoizedDateChats.yesterdayItem) && memoizedDateChats.yesterdayItem?.length > 0 && (
                  <>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'Manrope',
                        fontWeight: theme.infoText,
                        textAlign: 'center',
                        letterSpacing: '1px',
                      }}
                    >
                      {' '}
                      {yesterdayLabel}{' '}
                    </Typography>
                    {memoizedDateChats.yesterdayItem?.map((message, index) => (
                      <ListItemButton className="d-flex bd-highlight" alignItems="flex-start" key={index}>
                        {message?.messageType !== 'CHAT' ? (
                          <Alert severity="success" sx={{ minWidth: '100%' }}>
                            {message?.message}
                          </Alert>
                        ) : (
                          <>
                            <ListItemAvatar className="bd-highlight" onClick={() => goToProfilePage(message)}>
                              <Badge
                                overlap="circular"
                                onClick={() => navigate(`/profile/${message?.name?.replace(/\s+/g, '-')}-${message?.userId}`)}
                                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                badgeContent={
                                  message?.organizer ? (
                                    <OrganiserCrownIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : message?.moderator ? (
                                    <ModeratorStarIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : null
                                }
                              >
                                <Avatar
                                  alt={`${message?.name}` ? '' : getInitials(message?.name)}
                                  src={message?.profileImage}
                                  sx={{
                                    fontSize: message?.name ? 'default' : '12px',
                                  }}
                                >
                                  {' '}
                                  {getInitials(message?.name)}
                                </Avatar>
                              </Badge>
                            </ListItemAvatar>
                            <Box className="bd-highlight">
                              {message?.replyToMessageId !== 0 && message?.replyToMessageId !== null && (
                                <>
                                  <Box className={isDarkMode ? `chat-container-dark` : `chat-container`}>
                                    <div className={isDarkMode ? 'reply-section' : 'reply-section'}>
                                      <div className="reply-info">
                                        <p
                                          className="reply-user"
                                          style={{
                                            color:
                                              message?.replyToMessageUserId === userDetails?.id
                                                ? isDarkMode
                                                  ? '#ffce00'
                                                  : 'primary.light'
                                                : 'inherit',
                                          }}
                                        >
                                          {message?.replyToMessageUserId === userDetails?.id
                                            ? message?.replyToMessageUser
                                            : message?.replyToMessageUser}
                                        </p>
                                        <span className="reply-text">{message?.replyToMessage}</span>
                                      </div>
                                    </div>
                                  </Box>
                                </>
                              )}
                              <ListItemText
                                primary={
                                  <React.Fragment>
                                    <Typography
                                      sx={{
                                        display: 'inline',
                                        fontWeight: '600',
                                        color:
                                          message?.replyToMessageUserId === userDetails?.id
                                            ? isDarkMode
                                              ? '#ffce00'
                                              : 'primary.light'
                                            : 'inherit',
                                      }}
                                      component="span"
                                      variant="body2"
                                      color={isDarkMode ? '#ffce00' : 'text.primary'}
                                    >
                                      {message?.userId === userDetails?.id ? 'You' : message.name} &nbsp;
                                    </Typography>
                                    {moment(message?.chatPostedOn).fromNow()}
                                    <>
                                      {Array.isArray(message?.eventGallery) && message.eventGallery.length > 0 && (
                                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                          {message.eventGallery.map((media, index) => (
                                            <Box key={`${media.id || index}-${media.type}`}>
                                              {media.type === 'images' && <ImageComponent additionalData={media} />}
                                              {media.type === 'videos' && <VideoComponent additionalData={media} />}
                                              {media.type === 'pdf' && <PdfComponent additionalData={media} />}
                                            </Box>
                                          ))}
                                        </Box>
                                      )}
                                    </>
                                  </React.Fragment>
                                }
                                sx={{ wordBreak: 'break-all' }}
                                secondary={message?.message}
                              />
                              <div style={{ display: 'flex', gap: '8px' }}>
                                {message?.chatReactions?.length > 0 &&
                                  message?.chatReactions?.map((reaction, index) => (
                                    <Box
                                      sx={{
                                        width: '40px',
                                        height: '25px',
                                        background: isDarkMode ? '#1f1f26' : '#e0e0e0',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: '#fff',
                                        borderRadius: '10px',
                                        fontSize: ' 16px',
                                        display: 'flex',
                                        cursor: 'pointer',
                                      }}
                                      key={index}
                                    >
                                      <Typography>{reaction?.reaction}</Typography>
                                      <Typography sx={{ color: !isDarkMode ? '#292D34' : '' }}>{reaction?.count}</Typography>
                                    </Box>
                                  ))}
                              </div>
                            </Box>
                            <Box className="ms-auto  bd-highlight">
                              {(((activityDetails?.activityStatus === 'OPEN' ||
                                activityDetails?.activityStatus === 'ONGOING' ||
                                activityDetails?.activityStatus === 'RUNNING' ||
                                activityDetails?.activityStatus === 'ENDED' ||
                                activityDetails?.activityStatus === 'COMPLETED') &&
                                activityDetails?.participant === true) ||
                                ((activityDetails?.petitionStatus === 'OPEN' ||
                                  activityDetails?.petitionStatus === 'NOTIFIED' ||
                                  activityDetails?.petitionStatus === 'EXTENDED' ||
                                  activityDetails?.petitionStatus === 'COMPLETED') &&
                                  activityDetails?.participant === true)) && (
                                  <span className="d-flex align-items-center">
                                    {message?.pinned === true && (
                                      <Tooltip title="Pinned">
                                        <ChatPinIcon sx={{ fontSize: 'medium' }}></ChatPinIcon>
                                      </Tooltip>
                                    )}
                                    <Tooltip title="Reaction">
                                      <ChatReaction
                                        message={message}
                                        chatData={getAllConversation}
                                        onSelectEmoji={handleEmojiSelect}
                                        onClose={data => handleReactClose(data)}
                                      />
                                    </Tooltip>
                                    <Tooltip title="Reply">
                                      <ReplayIcon className="m-2" sx={{ fontSize: 'medium' }} onClick={() => handleReply(message)} />
                                    </Tooltip>
                                    <Tooltip title="More">
                                      <ChatOptions
                                        handleMenuItemClick={handleMenuItemClick}
                                        message={message}
                                        chatDetails={activityDetails}
                                      />
                                    </Tooltip>
                                  </span>
                                )}
                            </Box>
                          </>
                        )}
                      </ListItemButton>
                    ))}
                  </>
                )}
                {Array.isArray(memoizedDateChats.todayItem) && memoizedDateChats.todayItem?.length > 0 && (
                  <>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'Manrope',
                        fontWeight: theme.infoText,
                        textAlign: 'center',
                        letterSpacing: '1px',
                      }}
                    >
                      {' '}
                      {todayLabel}{' '}
                    </Typography>
                    {memoizedDateChats.todayItem?.map((message, index) => (
                      <ListItemButton className="d-flex bd-highlight" alignItems="flex-start" key={index}>
                        {message?.messageType !== 'CHAT' ? (
                          <Alert severity="success" sx={{ minWidth: '100%' }}>
                            {message?.message}
                          </Alert>
                        ) : (
                          <>
                            <ListItemAvatar className="bd-highlight" onClick={() => goToProfilePage(message)}>
                              <Badge
                                overlap="circular"
                                onClick={() => navigate(`/profile/${message?.name?.replace(/\s+/g, '-')}-${message?.userId}`)}
                                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                badgeContent={
                                  message?.organizer ? (
                                    <OrganiserCrownIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : message?.moderator ? (
                                    <ModeratorStarIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : null
                                }
                              >
                                <Avatar
                                  alt={`${message?.name}` ? '' : getInitials(message?.name)}
                                  src={message?.profileImage}
                                  sx={{
                                    fontSize: message?.name ? 'default' : '12px',
                                  }}
                                >
                                  {' '}
                                  {getInitials(message?.name)}
                                </Avatar>
                              </Badge>
                            </ListItemAvatar>
                            <Box className="bd-highlight">
                              {message?.replyToMessageId !== 0 && message?.replyToMessageId !== null && (
                                <>
                                  <Box className={isDarkMode ? `chat-container-dark` : `chat-container`}>
                                    <div className={isDarkMode ? 'reply-section' : 'reply-section'}>
                                      <div className="reply-info">
                                        <p
                                          className="reply-user"
                                          style={{
                                            color:
                                              message?.replyToMessageUserId === userDetails?.id
                                                ? isDarkMode
                                                  ? '#ffce00'
                                                  : 'primary.light'
                                                : 'inherit',
                                          }}
                                        >
                                          {message?.replyToMessageUserId === userDetails?.id
                                            ? message?.replyToMessageUser
                                            : message?.replyToMessageUser}
                                        </p>
                                        <span className="reply-text">{message?.replyToMessage}</span>
                                      </div>
                                    </div>
                                  </Box>
                                </>
                              )}
                              <ListItemText
                                primary={
                                  <React.Fragment>
                                    <Typography
                                      sx={{
                                        display: 'inline',
                                        fontWeight: '600',
                                        color:
                                          message?.replyToMessageUserId === userDetails?.id
                                            ? isDarkMode
                                              ? '#ffce00'
                                              : 'primary.light'
                                            : 'inherit',
                                      }}
                                      component="span"
                                      variant="body2"
                                      color={isDarkMode ? '#ffce00' : 'text.primary'}
                                    >
                                      {message?.userId === userDetails?.id ? 'You' : message.name} &nbsp;
                                    </Typography>
                                    {moment(message?.chatPostedOn).fromNow()}
                                    <>
                                      {Array.isArray(message?.eventGallery) && message.eventGallery.length > 0 && (
                                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                          {message.eventGallery.map((media, index) => (
                                            <Box key={`${media.id || index}-${media.type}`}>
                                              {media.type === 'images' && <ImageComponent additionalData={media} />}
                                              {media.type === 'videos' && <VideoComponent additionalData={media} />}
                                              {media.type === 'pdf' && <PdfComponent additionalData={media} />}
                                            </Box>
                                          ))}
                                        </Box>
                                      )}
                                    </>
                                  </React.Fragment>
                                }
                                sx={{ wordBreak: 'break-all' }}
                                secondary={message?.message}
                              />
                              <div style={{ display: 'flex', gap: '8px' }}>
                                {message?.chatReactions?.length > 0 &&
                                  message?.chatReactions?.map((reaction, index) => (
                                    <Box
                                      sx={{
                                        width: '40px',
                                        height: '25px',
                                        background: isDarkMode ? '#1f1f26' : '#e0e0e0',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: '#fff',
                                        borderRadius: '10px',
                                        fontSize: ' 16px',
                                        display: 'flex',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <Typography>{reaction?.reaction}</Typography>
                                      <Typography sx={{ color: !isDarkMode ? '#292D34' : '' }}>{reaction?.count}</Typography>
                                    </Box>
                                  ))}
                              </div>
                            </Box>
                            <Box className="ms-auto  bd-highlight">
                              {(((activityDetails?.activityStatus === 'OPEN' ||
                                activityDetails?.activityStatus === 'ONGOING' ||
                                activityDetails?.activityStatus === 'RUNNING' ||
                                activityDetails?.activityStatus === 'ENDED' ||
                                activityDetails?.activityStatus === 'COMPLETED') &&
                                activityDetails?.participant === true) ||
                                ((activityDetails?.petitionStatus === 'OPEN' ||
                                  activityDetails?.petitionStatus === 'NOTIFIED' ||
                                  activityDetails?.petitionStatus === 'EXTENDED' ||
                                  activityDetails?.petitionStatus === 'COMPLETED') &&
                                  activityDetails?.participant === true)) && (
                                  <span className="d-flex align-items-center">
                                    {message?.pinned === true && (
                                      <Tooltip title="Pinned">
                                        <ChatPinIcon sx={{ fontSize: 'medium' }}></ChatPinIcon>
                                      </Tooltip>
                                    )}
                                    <Tooltip title="Reaction">
                                      <ChatReaction
                                        message={message}
                                        chatData={getAllConversation}
                                        onSelectEmoji={handleEmojiSelect}
                                        onClose={data => handleReactClose(data)}
                                      />
                                    </Tooltip>
                                    <Tooltip title="Reply">
                                      <ReplayIcon className="m-2" sx={{ fontSize: 'medium' }} onClick={() => handleReply(message)} />
                                    </Tooltip>
                                    <Tooltip title="More">
                                      <ChatOptions
                                        handleMenuItemClick={handleMenuItemClick}
                                        message={message}
                                        chatDetails={activityDetails}
                                      />
                                    </Tooltip>
                                  </span>
                                )}
                            </Box>
                          </>
                        )}
                      </ListItemButton>
                    ))}
                  </>
                )}
                {Array.isArray(memoizedDateChats.unReadItem) && memoizedDateChats.unReadItem?.length > 0 && (
                  <>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'Manrope',
                        fontWeight: theme.infoText,
                        textAlign: 'center',
                        letterSpacing: '1px',
                      }}
                    >
                      {' '}
                      {unreadLabel}{' '}
                    </Typography>
                    {memoizedDateChats.unReadItem?.map((message, index) => (
                      <ListItemButton className="d-flex bd-highlight" alignItems="flex-start" key={index}>
                        {message?.messageType !== 'CHAT' ? (
                          <Alert severity="success" sx={{ minWidth: '100%' }}>
                            {message?.message}
                          </Alert>
                        ) : (
                          <>
                            <ListItemAvatar className="bd-highlight" onClick={() => goToProfilePage(message)}>
                              <Badge
                                overlap="circular"
                                onClick={() => navigate(`/profile/${message?.name?.replace(/\s+/g, '-')}-${message?.userId}`)}
                                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                badgeContent={
                                  message?.organizer ? (
                                    <OrganiserCrownIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : message?.moderator ? (
                                    <ModeratorStarIcon sx={{ height: 'unset', width: 'unset', rotate: '-51deg' }} />
                                  ) : null
                                }
                              >
                                <Avatar
                                  alt={`${message?.name}` ? '' : getInitials(message?.name)}
                                  src={message?.profileImage}
                                  sx={{
                                    fontSize: message?.name ? 'default' : '12px',
                                  }}
                                >
                                  {' '}
                                  {getInitials(message?.name)}
                                </Avatar>
                              </Badge>
                            </ListItemAvatar>
                            <Box className="bd-highlight">
                              {message?.replyToMessageId !== 0 && message?.replyToMessageId !== null && (
                                <>
                                  <Box className={isDarkMode ? `chat-container-dark` : `chat-container`}>
                                    <div className={isDarkMode ? 'reply-section' : 'reply-section'}>
                                      <div className="reply-info">
                                        <p
                                          className="reply-user"
                                          style={{
                                            color:
                                              message?.replyToMessageUserId === userDetails?.id
                                                ? isDarkMode
                                                  ? '#ffce00'
                                                  : 'primary.light'
                                                : 'inherit',
                                          }}
                                        >
                                          {message?.replyToMessageUserId === userDetails?.id
                                            ? message?.replyToMessageUser
                                            : message?.replyToMessageUser}
                                        </p>
                                        <span className="reply-text">{message?.replyToMessage}</span>
                                      </div>
                                    </div>
                                  </Box>
                                </>
                              )}
                              <ListItemText
                                primary={
                                  <React.Fragment>
                                    <Typography
                                      sx={{
                                        display: 'inline',
                                        fontWeight: '600',
                                        color: pinnedData?.userId === userDetails?.id ? 'primary.light' : 'inherit',
                                      }}
                                      component="span"
                                      variant="body2"
                                      color={isDarkMode ? '#ffce00' : 'text.primary'}
                                    >
                                      {message?.userId === userDetails?.id ? 'You' : message.name} &nbsp;
                                    </Typography>
                                    {moment(message?.chatPostedOn).fromNow()}
                                    <>
                                      {Array.isArray(message?.eventGallery) && message.eventGallery.length > 0 && (
                                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                          {message.eventGallery.map((media, index) => (
                                            <Box key={`${media.id || index}-${media.type}`}>
                                              {media.type === 'images' && <ImageComponent additionalData={media} />}
                                              {media.type === 'videos' && <VideoComponent additionalData={media} />}
                                              {media.type === 'pdf' && <PdfComponent additionalData={media} />}
                                            </Box>
                                          ))}
                                        </Box>
                                      )}
                                    </>
                                  </React.Fragment>
                                }
                                sx={{ wordBreak: 'break-all' }}
                                secondary={message?.message}
                              />
                              <div style={{ display: 'flex', gap: '8px' }}>
                                {message?.chatReactions?.length > 0 &&
                                  message?.chatReactions?.map((reaction, index) => (
                                    <Box
                                      sx={{
                                        width: '40px',
                                        height: '25px',
                                        background: isDarkMode ? '#1f1f26' : '#e0e0e0',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: '#fff',
                                        borderRadius: '10px',
                                        fontSize: ' 16px',
                                        display: 'flex',
                                        cursor: 'pointer',
                                      }}
                                      key={index}
                                    >
                                      <Typography>{reaction?.reaction}</Typography>
                                      <Typography sx={{ color: !isDarkMode ? '#292D34' : '' }}>{reaction?.count}</Typography>
                                    </Box>
                                  ))}
                              </div>
                            </Box>
                            <Box className="ms-auto  bd-highlight">
                              {(((activityDetails?.activityStatus === 'OPEN' ||
                                activityDetails?.activityStatus === 'ONGOING' ||
                                activityDetails?.activityStatus === 'RUNNING' ||
                                activityDetails?.activityStatus === 'ENDED' ||
                                activityDetails?.activityStatus === 'COMPLETED') &&
                                activityDetails?.participant === true) ||
                                ((activityDetails?.petitionStatus === 'OPEN' ||
                                  activityDetails?.petitionStatus === 'NOTIFIED' ||
                                  activityDetails?.petitionStatus === 'EXTENDED' ||
                                  activityDetails?.petitionStatus === 'COMPLETED') &&
                                  activityDetails?.participant === true)) && (
                                  <span className="d-flex align-items-center">
                                    {message?.pinned === true && (
                                      <Tooltip title="Pinned">
                                        <ChatPinIcon sx={{ fontSize: 'medium' }}></ChatPinIcon>
                                      </Tooltip>
                                    )}
                                    <Tooltip title="Reaction">
                                      <ChatReaction
                                        message={message}
                                        chatData={getAllConversation}
                                        onSelectEmoji={handleEmojiSelect}
                                        onClose={data => handleReactClose(data)}
                                      />
                                    </Tooltip>
                                    <Tooltip title="Reply">
                                      <ReplayIcon className="m-2" sx={{ fontSize: 'medium' }} onClick={() => handleReply(message)} />
                                    </Tooltip>
                                    <Tooltip title="More">
                                      <ChatOptions
                                        handleMenuItemClick={handleMenuItemClick}
                                        message={message}
                                        chatDetails={activityDetails}
                                      />
                                    </Tooltip>
                                  </span>
                                )}
                            </Box>
                          </>
                        )}
                      </ListItemButton>
                    ))}
                  </>
                )}
              </>
            ) : (
              !getAllConversation && (
                <>
                  <Box sx={{ pt: 0.5 }}>
                    <Skeleton variant="rectangular" width={210} height={118} />
                    <Skeleton width="60%" />
                    <Skeleton width="60%" />
                  </Box>
                  <Box sx={{ pt: 0.5 }}>
                    <Skeleton variant="rectangular" width={210} height={118} />
                    <Skeleton width="60%" />
                    <Skeleton width="60%" />
                  </Box>
                  <Box sx={{ pt: 0.5 }}>
                    <Skeleton variant="rectangular" width={210} height={118} />
                    <Skeleton width="60%" />
                    <Skeleton width="60%" />
                  </Box>
                </>
              )
            )}
          </div>
        </div>
      </div>
      <Box className="card-footer mob-input">
        {activityData?.eventType.toUpperCase() === 'ACTIVITY' && (
          <>
            {activityDetails?.activityStatus === 'OPEN' && activityDetails?.chatable === true && (
              <>
                <Box sx={{ background: isDarkMode ? '' : '#fff', marginTop: reply ? '-50px' : 'unset' }}>
                  {reply && (
                    <Box
                      sx={{
                        px: 7,
                        py: 0,
                        background: isDarkMode ? '#6f6f6f' : '#faf9ff',
                        borderRadius: '0px',
                        padding: '1.2% 2%',
                        position: 'relative',
                        width: '100%',
                        margin: '0 auto',
                        zIndex: 100,
                      }}
                    >
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          background: isDarkMode ? 'transparant' : 'white',
                          zIndex: 1,
                        }}
                        onClick={() => closeReply()}
                      >
                        <CloseIcon />
                      </IconButton>
                      <Typography
                        sx={{
                          fontSize: 14,
                          marginBottom: '0.11em',
                          color: replyData?.userId === userDetails?.id ? (isDarkMode ? '#ffce00' : 'primary.light') : 'text.secondary',
                        }}
                        gutterBottom
                      >
                        Replying to {replyData?.userId == userDetails?.id ? 'yourself' : replyData.name}
                      </Typography>
                      <Typography variant="body2">
                        {' '}
                        {replyData?.message?.length > 20 ? replyData?.message?.slice(0, 20) + '...' : replyData?.message}
                      </Typography>
                    </Box>
                  )}

                  <Box className="input-group input-width my-3">
                    <Box className="input-group-append">
                      <span
                        className="input-group-text attach_btn"
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        }}
                      >
                        <ControlPointIcon onClick={openImageUploader} sx={{ color: isDarkMode ? '#ffce00' : '#674bff' }} />
                        {isImageUploaderOpen && <ChatMediaOption anchorEl={anchorEle} onClose={cloeImageUploader} />}
                      </span>
                    </Box>

                    <input
                      type="file"
                      id="imageInput"
                      style={{ display: 'none' }}
                      onChange={handleFileSelect}
                      multiple
                      accept="image/*,video/*,application/pdf"
                    />

                    <br />
                    <input
                      placeholder={'Type your message'}
                      disabled={false}
                      style={{
                        background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        color: theme.palette.mode === 'dark' ? theme.placeholder.dark : theme.placeholder.light,
                        fontSize: '14px',
                        paddingTop: '2px',
                        border: 'none',
                        outline: 'none',
                        width: '100%',
                        height: '60px',
                        flex: 1,
                      }}
                      ref={inputRef}
                      onKeyDown={handleKeyDown}
                    />
                    <Box className="input-group-append">
                      <span
                        className="input-group-text send_btn align-items-baseline "
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                          paddingBottom: '0px',
                        }}
                      >
                        {' '}
                        <Box sx={{ position: 'relative', bottom: ' 9px' }}>
                          <ChatReactionMessage
                            message={message}
                            onSelectEmojiMessage={handleEmojiMessageSelect}
                            onClose={() => setReacted(false)}
                          />
                        </Box>
                        {disableImage ? (
                          <CircularProgress size={24} sx={{ color: 'secondary.main' }} />
                        ) : (
                          <>
                            {(files.length > 0 || message.trim().length > 0 || mediaSelected.length > 0) && (
                              <CloseIcon
                                onClick={removeSelectedMedia}
                                sx={{ color: 'error.main', cursor: 'pointer', marginRight: '8px' }}
                              />
                            )}
                            <SendIcon onClick={() => handleSendIconClick(reply)} sx={{ color: 'secondary.main' }} />
                          </>
                        )}
                      </span>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
            {activityDetails?.activityStatus === 'ONGOING' && activityDetails?.chatable === true && (
              <>
                <Box sx={{ background: isDarkMode ? '' : '#fff', marginTop: reply ? '-50px' : 'unset' }}>
                  {reply && (
                    <Box
                      sx={{
                        px: 7,
                        py: 0,
                        background: isDarkMode ? '#6f6f6f' : '#faf9ff',
                        borderRadius: '0px',
                        padding: '1.2% 2%',
                        position: 'relative',
                        zIndex: 100,
                      }}
                    >
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          background: isDarkMode ? 'transparant' : 'white',
                          zIndex: 1,
                        }}
                        onClick={() => closeReply()}
                      >
                        <CloseIcon />
                      </IconButton>
                      <Typography
                        sx={{
                          fontSize: 14,
                          marginBottom: '0.11em',
                          color: replyData?.userId === userDetails?.id ? (isDarkMode ? '#ffce00' : 'primary.light') : 'text.secondary',
                        }}
                        gutterBottom
                      >
                        Replying to {replyData?.userId == userDetails?.id ? 'yourself' : replyData.name}
                      </Typography>
                      <Typography variant="body2">
                        {' '}
                        {replyData?.message?.length > 20 ? replyData?.message?.slice(0, 20) + '...' : replyData?.message}
                      </Typography>
                    </Box>
                  )}
                  <Box className="input-group input-width my-3">
                    <Box className="input-group-append">
                      <span
                        className="input-group-text attach_btn"
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        }}
                      >
                        <ControlPointIcon onClick={openImageUploader} sx={{ color: '#674bff' }} />
                        {isImageUploaderOpen && <ChatMediaOption anchorEl={anchorEle} onClose={cloeImageUploader} />}
                      </span>
                    </Box>

                    <input
                      type="file"
                      id="imageInput"
                      style={{ display: 'none' }}
                      onChange={handleFileSelect}
                      multiple
                      accept="image/*,video/*,application/pdf"
                    />

                    <br />
                    <input
                      placeholder="Type your message"
                      disabled={false}
                      style={{
                        background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        color: theme.palette.mode === 'dark' ? theme.placeholder.dark : theme.placeholder.light,
                        fontSize: '14px',
                        paddingTop: '2px',
                        border: 'none',
                        outline: 'none',
                        width: '70%',
                      }}
                      ref={inputRef}
                      onKeyDown={handleKeyDown}
                    />
                    <Box className="input-group-append">
                      <span
                        className="input-group-text send_btn align-items-baseline "
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                          paddingBottom: '0px',
                        }}
                      >
                        {' '}
                        <Box sx={{ position: 'relative', bottom: ' 9px' }}>
                          <ChatReactionMessage
                            message={message}
                            onSelectEmojiMessage={handleEmojiMessageSelect}
                            onClose={() => setReacted(false)}
                          />
                        </Box>
                        {disableImage ? (
                          <CircularProgress size={24} sx={{ color: 'secondary.main' }} />
                        ) : (
                          <>
                            {(files.length > 0 || message.trim().length > 0 || mediaSelected.length > 0) && (
                              <CloseIcon
                                onClick={removeSelectedMedia}
                                sx={{ color: 'error.main', cursor: 'pointer', marginRight: '8px' }}
                              />
                            )}
                            <SendIcon onClick={() => handleSendIconClick(reply)} sx={{ color: 'secondary.main' }} />
                          </>
                        )}
                      </span>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
            {activityDetails?.activityStatus === 'RUNNING' && activityDetails?.chatable === true && (
              <>
                <Box sx={{ background: isDarkMode ? '' : '#fff', marginTop: reply ? '-50px' : 'unset' }}>
                  {reply && (
                    <Box
                      sx={{
                        px: 7,
                        py: 0,
                        background: isDarkMode ? '#6f6f6f' : '#faf9ff',
                        borderRadius: '0px',
                        padding: '1.2% 2%',
                        position: 'relative',
                        zIndex: 100,
                      }}
                    >
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          background: isDarkMode ? 'transparant' : 'white',
                          zIndex: 1,
                        }}
                        onClick={() => closeReply()}
                      >
                        <CloseIcon />
                      </IconButton>
                      <Typography
                        sx={{
                          fontSize: 14,
                          marginBottom: '0.11em',
                          color: replyData?.userId === userDetails?.id ? (isDarkMode ? '#ffce00' : 'primary.light') : 'text.secondary',
                        }}
                        gutterBottom
                      >
                        Replying to {replyData?.userId == userDetails?.id ? 'yourself' : replyData.name}
                      </Typography>
                      <Typography variant="body2">
                        {' '}
                        {replyData?.message?.length > 20 ? replyData?.message?.slice(0, 20) + '...' : replyData?.message}
                      </Typography>
                    </Box>
                  )}
                  <Box className="input-group input-width my-3">
                    <Box className="input-group-append">
                      <span
                        className="input-group-text attach_btn"
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        }}
                      >
                        <ControlPointIcon onClick={openImageUploader} sx={{ color: '#674bff' }} />
                        {isImageUploaderOpen && <ChatMediaOption anchorEl={anchorEle} onClose={cloeImageUploader} />}
                      </span>
                    </Box>

                    <input
                      type="file"
                      id="imageInput"
                      style={{ display: 'none' }}
                      onChange={handleFileSelect}
                      multiple
                      accept="image/*,video/*,application/pdf"
                    />

                    <br />
                    <input
                      placeholder="Type your message"
                      style={{
                        background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        color: theme.palette.mode === 'dark' ? theme.placeholder.dark : theme.placeholder.light,
                        fontSize: '14px',
                        paddingTop: '2px',
                        border: 'none',
                        outline: 'none',
                        width: '100%',
                        flex: 1,
                      }}
                      ref={inputRef}
                      onKeyDown={handleKeyDown}
                    />
                    <Box className="input-group-append">
                      <span
                        className="input-group-text send_btn align-items-baseline "
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                          paddingBottom: '0px',
                        }}
                      >
                        {' '}
                        <Box sx={{ position: 'relative', bottom: ' 9px' }}>
                          <ChatReactionMessage
                            message={message}
                            onSelectEmojiMessage={handleEmojiMessageSelect}
                            onClose={() => setReacted(false)}
                          />
                        </Box>
                        {disableImage ? (
                          <CircularProgress size={24} sx={{ color: 'secondary.main' }} />
                        ) : (
                          <>
                            {(files.length > 0 || message.trim().length > 0 || mediaSelected.length > 0) && (
                              <CloseIcon
                                onClick={removeSelectedMedia}
                                sx={{ color: 'error.main', cursor: 'pointer', marginRight: '8px' }}
                              />
                            )}
                            <SendIcon onClick={() => handleSendIconClick(reply)} sx={{ color: 'secondary.main' }} />
                          </>
                        )}
                      </span>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
            {activityDetails?.activityStatus === 'OPEN' && activityDetails?.chatable === false && (
              <>
                <Typography
                  sx={{
                    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#676E7B',
                    fontSize: '14px',
                    fontFamily: 'Manrope',
                    textAlign: 'center',
                    paddingBottom: '7%',
                    paddingTop: '6%',
                  }}
                >
                  Be part of this Activity to engage in this conversation
                </Typography>
              </>
            )}
            {activityDetails?.activityStatus === 'ONGOING' && activityDetails?.chatable === false && (
              <>
                <Typography
                  sx={{
                    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#676E7B',
                    fontSize: '14px',
                    fontFamily: 'Manrope',
                    textAlign: 'center',
                    paddingBottom: '7%',
                    paddingTop: '6%',
                  }}
                >
                  You won't be able to engage in the conversations as you are not part of the activity
                </Typography>
              </>
            )}
            {activityDetails?.activityStatus === 'RUNNING' && activityDetails?.chatable === false && (
              <>
                <Typography
                  sx={{
                    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#676E7B',
                    fontSize: '14px',
                    fontFamily: 'Manrope',
                    textAlign: 'center',
                    paddingBottom: '7%',
                    paddingTop: '6%',
                  }}
                >
                  You won't be able to engage in the conversations as you are not part of the activity
                </Typography>
              </>
            )}
            {activityDetails?.activityStatus === 'ENDED' && activityDetails?.chatable === false && (
              <>
                <Typography
                  sx={{
                    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#676E7B',
                    fontSize: '14px',
                    fontFamily: 'Manrope',
                    textAlign: 'center',
                    paddingBottom: '7%',
                    paddingTop: '6%',
                  }}
                >
                  You won't be able to engage in the conversations as you are not part of the activity
                </Typography>
              </>
            )}
            {activityDetails?.activityStatus === 'COMPLETED' && (
              <>
                <Typography
                  sx={{
                    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#676E7B',
                    fontSize: '14px',
                    fontFamily: 'Manrope',
                    textAlign: 'center',
                    paddingBottom: '7%',
                    paddingTop: '6%',
                  }}
                >
                  Please note that this activity has been completed and is no longer available for further discussion.
                  {!activityData?.organiser && '.'}
                  {activityData?.organiser && (
                    <Link to={`/activity/${activityData?.id}`} style={{ textDecoration: 'none', color: '#674BFF' }}>
                      , read review here{' '}
                    </Link>
                  )}
                </Typography>
              </>
            )}
            {activityDetails?.activityStatus === 'ENDED' && activityDetails?.chatable === true && (
              <>
                <Box sx={{ background: isDarkMode ? '' : '#fff', marginTop: reply ? '-50px' : 'unset' }}>
                  {reply && (
                    <Box
                      sx={{
                        px: 7,
                        py: 0,
                        background: isDarkMode ? '#6f6f6f' : '#faf9ff',
                        borderRadius: '0px',
                        padding: '1.2% 2%',
                        position: 'relative',
                        zIndex: 100,
                      }}
                    >
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          background: isDarkMode ? 'transparant' : 'white',
                          zIndex: 1,
                        }}
                        onClick={() => closeReply()}
                      >
                        <CloseIcon />
                      </IconButton>
                      <Typography
                        sx={{
                          fontSize: 14,
                          marginBottom: '0.11em',
                          color: replyData?.userId === userDetails?.id ? (isDarkMode ? '#ffce00' : 'primary.light') : 'text.secondary',
                        }}
                        gutterBottom
                      >
                        Replying to {replyData?.userId == userDetails?.id ? 'yourself' : replyData.name}
                      </Typography>
                      <Typography variant="body2">
                        {' '}
                        {replyData?.message?.length > 20 ? replyData?.message?.slice(0, 20) + '...' : replyData?.message}
                      </Typography>
                    </Box>
                  )}
                  <Box
                    className="input-group input-width my-3"
                    sx={{
                      display: 'flex',
                      flexWrap: 'nowrap',
                    }}
                  >
                    <Box className="input-group-append">
                      <span
                        className="input-group-text attach_btn"
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        }}
                      >
                        <ControlPointIcon onClick={openImageUploader} sx={{ color: '#674bff' }} />
                        {isImageUploaderOpen && <ChatMediaOption anchorEl={anchorEle} onClose={cloeImageUploader} />}
                      </span>
                    </Box>

                    <input
                      type="file"
                      id="imageInput"
                      style={{ display: 'none' }}
                      onChange={handleFileSelect}
                      multiple
                      accept="image/*,video/*,application/pdf"
                    />
                    <br />
                    <input
                      placeholder="You can only upload images and videos as the activity has ended."
                      style={{
                        background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                        color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#333',
                        fontSize: '14px',
                        paddingTop: '2px',
                        border: 'none',
                        outline: 'none',
                        width: '78%',
                      }}
                      ref={inputRef}
                      onKeyDown={handleKeyDown}
                      readOnly={true}
                    />
                    <Box className="input-group-append">
                      <span
                        className="input-group-text send_btn align-items-baseline"
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                          paddingBottom: message ? '25%' : '40%',
                        }}
                      >
                        <Box sx={{ position: 'relative', bottom: ' 9px' }}></Box>
                        {disableImage ? (
                          <CircularProgress size={24} sx={{ color: 'secondary.main' }} />
                        ) : (
                          <>
                            {(files.length > 0 || message.trim().length > 0 || mediaSelected.length > 0) && (
                              <CloseIcon
                                onClick={removeSelectedMedia}
                                sx={{ color: 'error.main', cursor: 'pointer', marginRight: '8px' }}
                              />
                            )}
                            <SendIcon onClick={() => handleSendIconClick(reply)} sx={{ color: 'secondary.main' }} />
                          </>
                        )}
                      </span>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </>
        )}
        {activityData?.eventType.toUpperCase() === 'PETITION' && (
          <>
            {(activityDetails?.petitionStatus === 'OPEN' || activityDetails?.petitionStatus === 'NOTIFIED') &&
              activityDetails?.hasPermission === true && (
                <>
                  <Box sx={{ background: isDarkMode ? '' : '#fff', marginTop: reply ? '-50px' : 'unset' }}>
                    {reply && (
                      <Box
                        sx={{
                          px: 7,
                          py: 0,
                          background: isDarkMode ? '#6f6f6f' : '#faf9ff',
                          borderRadius: '0px',
                          padding: '1.2% 2%',
                          position: 'relative',
                          zIndex: 100,
                        }}
                      >
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: '4px',
                            right: '4px',
                            background: isDarkMode ? 'transparant' : 'white',
                            zIndex: 1,
                          }}
                          onClick={() => closeReply()}
                        >
                          <CloseIcon />
                        </IconButton>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                          Replying to {replyData?.userId == userDetails?.id ? 'yourself' : replyData.name}
                        </Typography>
                        <Typography variant="body2">
                          {' '}
                          {replyData?.message?.length > 20 ? replyData?.message?.slice(0, 20) + '...' : replyData?.message}
                        </Typography>
                      </Box>
                    )}
                    <Box className="input-group input-width my-3">
                      <Box className="input-group-append">
                        <span
                          className="input-group-text attach_btn"
                          style={{ background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8' }}
                        >
                          <ControlPointIcon onClick={openImageUploader} sx={{ color: '#674bff' }} />
                          {isImageUploaderOpen && <ChatMediaOption anchorEl={anchorEle} onClose={cloeImageUploader} />}
                        </span>
                      </Box>

                      <input
                        type="file"
                        id="imageInput"
                        style={{ display: 'none' }}
                        onChange={handleFileSelect}
                        multiple
                        accept="image/*,video/*,application/pdf"
                      />

                      <br />
                      <input
                        placeholder="Type your message"
                        disabled={false}
                        style={{
                          background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                          color: theme.palette.mode === 'dark' ? theme.placeholder.dark : theme.placeholder.light,
                          fontSize: '14px',
                          paddingTop: '2px',
                          border: 'none',
                          outline: 'none',
                          width: '70%',
                        }}
                        ref={inputRef}
                        onKeyDown={handleKeyDown}
                      />
                      <Box className="input-group-append">
                        <span
                          className="input-group-text send_btn align-items-baseline"
                          style={{
                            background: theme.palette.mode === 'dark' ? '#1f1f26' : '#f6f7f8',
                            paddingBottom: '0px',
                          }}
                        >
                          <Box sx={{ position: 'relative', bottom: ' 9px' }}>
                            <ChatReactionMessage
                              message={message}
                              onSelectEmojiMessage={handleEmojiMessageSelect}
                              onClose={() => setReacted(false)}
                            />
                          </Box>
                          {disableImage ? (
                            <CircularProgress size={24} sx={{ color: 'secondary.main' }} />
                          ) : (
                            <>
                              {(files.length > 0 || message.trim().length > 0 || mediaSelected.length > 0) && (
                                <CloseIcon
                                  onClick={removeSelectedMedia}
                                  sx={{ color: 'error.main', cursor: 'pointer', marginRight: '8px' }}
                                />
                              )}
                              <SendIcon onClick={() => handleSendIconClick(reply)} sx={{ color: 'secondary.main' }} />
                            </>
                          )}
                        </span>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            {(activityDetails?.petitionStatus === 'OPEN' || activityDetails?.petitionStatus === 'NOTIFIED') &&
              activityDetails?.hasPermission === false && (
                <>
                  <>
                    <Typography
                      sx={{
                        color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#676E7B',
                        fontSize: '14px',
                        fontFamily: 'Manrope',
                        textAlign: 'center',
                        paddingBottom: '7%',
                        paddingTop: '6%',
                      }}
                    >
                      Only organizer can message here{' '}
                    </Typography>
                  </>
                </>
              )}
            {(activityDetails?.petitionStatus === 'COMPLETED' || activityDetails?.petitionStatus === 'ENDED') && (
              <>
                <Typography
                  sx={{
                    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#676E7B',
                    fontSize: '14px',
                    fontFamily: 'Manrope',
                    textAlign: 'center',
                    paddingBottom: '7%',
                    paddingTop: '6%',
                  }}
                >
                  This Petition has been closed{' '}
                </Typography>
              </>
            )}
          </>
        )}
      </Box>
    </List>
  );
};

export default ChatFeed;